import {Injectable} from "@angular/core";
import {DxLogoutStrategy} from "./dx-logout-strategy";
import {Observable, of} from "rxjs/index";
import {DxLogoutResult} from "../../../domain/authentication/dx-logout-result";
import {DxSessionService} from "../../dx-session.service";
import {DxOperationResultType} from "../../../../dx-core/domain/common/dx-operation-result-type";
import {tap} from "rxjs/internal/operators";


@Injectable()
export class DxSyncLogoutStrategy implements DxLogoutStrategy {

  constructor(private _sessionService: DxSessionService) { }

  public logout(): Observable<DxLogoutResult> {
    const result: DxLogoutResult = new DxLogoutResult();
    result.type = DxOperationResultType.SUCCESS;
    const observable = of(result);
    return observable.pipe(tap(res => {
      this._sessionService.closeSession();
    }));
  }
}
